import domainName from '../common/root-domain-name';
import { getClickSessionId } from '../handler/mkttrack-cookie-handler';

export const buildReferralPixelTrackingProperties = (eventName: string): Record<string, string> => {
  const deviceType = navigator.userAgent.includes('iPad') ? 'iPad' : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? 'mobile' : 'desktop';

  const propertyObj: any = {
    domain: domainName(),
    referrer: document.referrer,
    device: deviceType,
    eventname: eventName,
    type: 'Analytics Bootstrap',
    clicksessionid: getClickSessionId(),
  };

  return propertyObj || {};
};

window.buildReferralPixelTrackingProperties = buildReferralPixelTrackingProperties;

const postData = (propertyObj: Record<string, string>): void => {
  const pixelRequestUrl = new URL(`https://${PIXEL_HOSTNAME}/pixel/t`);
  fetch(pixelRequestUrl, {
    method: 'post',
    credentials: 'include',
    keepalive: true,
    body: JSON.stringify(propertyObj),
  }).catch(console.error);
};

export const sendToKafka = (eventName: string) => {
  const propertyObj = buildReferralPixelTrackingProperties(eventName);
  postData(propertyObj);
};

export default () => {
  if (!window.fireLaunchstrapBeginsOnce) {
    sendToKafka('launch_strap_begins');
    window.fireLaunchstrapBeginsOnce = true;
  }
};
